import { booleanAttribute } from "#ce/utils/props";

export const props = Object.freeze({
  /**
   * Whether the dialog is currently visible.
   *
   * @type {Boolean|String}
   * @default true
   */
  open: booleanAttribute(true),
  /**
   * Heading rendered in the dialog header. Ignored when the title slot is provided.
   *
   * @type {String}
   * @default undefined
   */
  title: {
    type: String,
    default: undefined,
  },
  /**
   * Body copy rendered between the header and the action row. Ignored when the default slot is provided.
   *
   * @type {String}
   * @default undefined
   */
  content: {
    type: String,
    default: undefined,
  },
  /**
   * Render an "x" close button in the header. Closing via this button neither confirms nor cancels.
   *
   * @type {Boolean|String}
   * @default false
   */
  closeable: booleanAttribute(),
  /**
   * Render a cancel button alongside the confirm button. Clicking it emits cancel and closes the dialog.
   *
   * @type {Boolean|String}
   * @default false
   */
  cancelable: booleanAttribute(),
  /**
   * Label of the cancel button. Ignored when the cancel slot is provided.
   *
   * @type {String}
   * @default "Cancel"
   */
  cancelLabel: {
    type: String,
    default: "Cancel",
  },
  /**
   * Label of the confirm button. Ignored when the confirm slot is provided.
   *
   * @type {String}
   * @default "Confirm"
   */
  confirmLabel: {
    type: String,
    default: "Confirm",
  },
  /**
   * Local-storage key used to remember a previous confirm. When set and the user has confirmed before, the dialog stays closed across reloads. Leave empty to show the dialog on every visit.
   *
   * @type {String}
   * @default undefined
   */
  persist: {
    type: String,
    default: undefined,
  },
});
